import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, HostBinding, NgModule } from '@angular/core';
import * as i1 from '@angular/platform-browser';

class VisuallyHiddenComponent {
    constructor(sanitizer) {
        this.style = sanitizer.bypassSecurityTrustStyle(`
      position: absolute;
      border: 0;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      white-space: nowrap;
      word-wrap: normal;
    `);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: VisuallyHiddenComponent, deps: [{ token: i1.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "18.1.4", type: VisuallyHiddenComponent, selector: "span[hy-visually-hidden], hy-visually-hidden", host: { properties: { "style": "this.style" } }, ngImport: i0, template: `<ng-content></ng-content>`, isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: VisuallyHiddenComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'span[hy-visually-hidden], hy-visually-hidden',
                    template: `<ng-content></ng-content>`,
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], ctorParameters: () => [{ type: i1.DomSanitizer }], propDecorators: { style: [{
                type: HostBinding,
                args: ['style']
            }] } });
const DIRECTIVES = [VisuallyHiddenComponent];
class VisuallyHiddenModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: VisuallyHiddenModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.1.4", ngImport: i0, type: VisuallyHiddenModule, declarations: [VisuallyHiddenComponent], exports: [VisuallyHiddenComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: VisuallyHiddenModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.1.4", ngImport: i0, type: VisuallyHiddenModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: DIRECTIVES,
                    exports: DIRECTIVES,
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { VisuallyHiddenComponent, VisuallyHiddenModule };
